import React from 'react'
import CloseIcon from 'assets/images/easyPay/close.svg'
import { useNavigate } from 'react-router-dom'
interface IHeaderProps {
    title: string
}
export default function Header({ title }: IHeaderProps) {
    const navigate = useNavigate()
    return (
        <>
            <div className=" bg-transparent w-full px-4 py-4 flex justify-between z-10 shadow-[0px 2px 4px 0px #0000001A] items-center">
                <div className="flex"></div>
                <p className=" text-green-1 text-xl font-black">{title}</p>
                <img
                    src={CloseIcon}
                    alt="close"
                    className=" cursor-pointer"
                    onClick={() => navigate(-1)}
                />
            </div>
        </>
    )
}
